import { Theme, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { memo } from 'react'
import { observer } from 'mobx-react'
import Tuev from 'components/DigitalAccountCheck/TrustElement/Tuev'
import { useStores } from 'stores/utils/hooks/useStores'
import isNotAffiliate from 'utils/formDependencies/conditions/isNotAffiliate'
import TrustCards from '../../../components/Smava/TrustCards'
// import PartnershipCards from '../../../components/Smava/PartnershipCards'

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    tuevText: {
      textAlign: 'center',
      padding: theme.spacing(3)
    },
    tuevLogo: {
      paddingBottom: theme.spacing(2)
    },
    tuevBanner: {
      width: '100%',
      backgroundColor: '#F3F4FC',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    legalText: {
      marginTop: '10px'
    },
    legalTextContainer: {
      maxWidth: '1200px',
      textAlign: 'left',
      fontSize: '12px',
      padding: `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(
        2
      )} ${theme.spacing(4)}`,
      margin: 'auto'
    },
    minAndMax: {
      marginBottom: '5px'
    }
  })
)

const SmavaFormFooter = observer(() => {
  const {
    tuevText,
    tuevLogo,
    tuevBanner,
    legalText,
    minAndMax,
    legalTextContainer
  } = useStyles()

  const {
    navigation: { tenantContext },
    traversal: { data }
  } = useStores()

  const notAffiliate = isNotAffiliate(data, tenantContext)

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item>
        <div className={tuevBanner}>
          <div className={tuevText}>
            <Typography variant="h5">
              TÜV zertifizierter Datenschutz nach DSGVO und BDSG
            </Typography>
          </div>
          <div className={tuevLogo}>
            <Tuev width="80px" />
          </div>
        </div>
      </Grid>
      {notAffiliate && (
        <Grid item>
          <TrustCards />
        </Grid>
      )}
      {/* <Grid item>
        <PartnershipCards />
      </Grid> */}
      <Grid item>
        <div className={legalTextContainer}>
          <div className={minAndMax}>
            <Typography variant="body2">
              <strong>Laufzeit: </strong>
              <span>Minimum 6 Monate, Maximum 120 Monate</span>
            </Typography>
          </div>
          <div className={minAndMax}>
            <Typography variant="body2">
              <strong>Zinssätze: </strong>
              <span>
                Minimum -0,40 % effektiver Jahreszins, Maximum 10,90 %
                effektiver Jahreszins
              </span>
            </Typography>
          </div>
          <div className={legalText}>
            <Typography variant="body2">
              <strong>Beispiel: </strong>
              <span>
                2/3 aller Kunden erhalten: Nettodarlehensbetrag 20.000,00 €, 84
                Monate Laufzeit, 4,71 % effekt. Jahreszins, 4,62 % fester
                Sollzins p.a., Gesamtbetrag 23.439,32 €, mtl. Rate 279,04 €,
                Solarisbank AG, Cuvrystraße 53, 10997 Berlin
              </span>
            </Typography>
          </div>
        </div>
      </Grid>
    </Grid>
  )
})

export default memo(SmavaFormFooter)
